import { useEffect } from 'react'
import { useField } from 'formik'
import { useTranslation } from 'react-i18next'
import useTenantProfileContext from '@/features/Profile/TenantProfileModal/tenant-profile-context'
import ToggleDescriptionField from '../ToggleDescriptionField'

const AllowCalls = ({ condensed }) => {
  const { t } = useTranslation()
  const [field] = useField('allow_calls')
  const tenantProfileContext = useTenantProfileContext()
  const setAllowCalls = tenantProfileContext?.setAllowCalls

  const title = t('r.settings.view.allow_calls.title', 'Allow landlords to call me')

  const description = field.value
    ? t(
        'r.settings.view.allow_calls.enabled.description',
        `Only landlords from the listings you've inquired about or applied to can see your phone number.`
      )
    : t(
        'r.settings.view.allow_calls.disabled.description',
        `Only landlords from the listings you've applied to can see your phone number.`
      )

  useEffect(() => {
    if (setAllowCalls) {
      setAllowCalls(field.value)
    }
  }, [field])

  return (
    <ToggleDescriptionField
      condensed={condensed}
      title={title}
      description={description}
      fieldName="allow_calls"
    />
  )
}

export default AllowCalls
